import React, { useState, useEffect, useContext } from 'react';
import { makeStyles,withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import ReactLoading from 'react-loading';
import Tooltip from '@material-ui/core/Tooltip';

import { SessionContext } from "../context/session-context";

var handleError = function (err) {
  console.log(err);
  return new Response(JSON.stringify({
    code: 400,
    message: 'Stupid network Error'
  }));
};

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: 75,
    left: 60,
    '&.MuiInputBase-input MuiInput-input':{
      margin: '50px',
    }
  },
  paper: {
    //backgroundColor: '#000000',
    backgroundColor: '#666666',
    display: 'flex',
    alignItems: 'center',
    width: 400,
    marginRight: 4,
    height: 42,
    color: '#FFFFFF',
  },
  input: {
    borderRadius: 5,
    marginLeft: 10,
    flex: 1,
    height: 28,
    backgroundColor: '#FFFFFF',
    '&.MuiInputBase-input MuiInput-input':{
      marginLeft: '10px',
    }
  },
  searchButton: {
    margin: 5,
    color: '#FFFFFF',
    height: 32,
    backgroundColor: '#0C4C35',
    '&:hover': {
      backgroundColor: '#63D764'
    },
  },
  textField: {
    width: '100%',
    minWidth: 200,
    marginTop:5,
    marginBottom:5,
    paddingLeft:5,
  },
  textItemFont:{
    fontSize:12,
    height: 16,
    padding: 8,
    backgroundColor:'#FFF',
  }
}));

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

export default function AddressSearchPaper() {
  const classes = useStyles();
  const [sState, sDispatch] = useContext(SessionContext);
  const [searchField, setSearchField] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [matchedAddress, setMatchedAddress] = useState({});

  useEffect(() => {
    if (searchField.length >= 2){ setDisabled(false); } else { setDisabled(true); }
  }, [searchField]);

  const handleSearch = () => {
    if (!isLoading){
      setIsLoading(true);
      //setOpen(true);

      //Check if address entered is coordinates.
      let isCoordinates = false;
      const splitAddress = searchField.split(' ');
      if (splitAddress.length === 2){
        if (!isNaN(parseInt(splitAddress[0])) && 
            !isNaN(parseInt(splitAddress[1])) && 
            splitAddress[0].length > 4 && splitAddress[0].length < 7 &&
            splitAddress[1].length > 4 && splitAddress[1].length < 7 ) {
              isCoordinates = true;
              setMatchedAddress([{
                key: 0,
                id: 0,
                address:'Coordinates: '+splitAddress[0]+' '+splitAddress[1],
                type: 'coordinates',
                x: parseInt(splitAddress[0]),
                y: parseInt(splitAddress[1]),
            }])
            return;
        }

      }

      if (!isCoordinates){
        const abortController = new AbortController();
        sDispatch({ type: "setUserAction", payload: { action: "addressSearch" } });
        //console.log("searchField value: "+searchField);
  
        const request = {
          ident: sState.ident,
          userid:sState.userid,
          search:searchField
        };
    
      let mounted = true;
      (async () => {
    
        const res = await fetch(process.env.REACT_APP_FIND_API+'/search/address', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            if (data.count !== 0){
              setMatchedAddress(data.data);
            } else {
              setMatchedAddress([{
                  id: -1,
                  address: 'No address found',
                  type: 'none',
                  x: 0,
                  y: 0,
              }])
            }
            //setAddressResponse(true);
          }
        }
        //setIsProcess(false);
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
    
        })();
      }
    }
  }

  const handleEnterSubmit = (e) => {
    
    if (e.key === 'Enter') {
        if (!disabled && searchField.length >= 2){
          handleSearch();
        }
        e.preventDefault();
    }
  };

  /**
   * Stores the results of address search.
   */
  useEffect(() => {
    if (matchedAddress.length > 0 ){
      //console.log("storeAddresses");
      sDispatch({
        type: "storeAddresses",
        payload: { 
          addresses:matchedAddress,
        }
      });
    }
    setIsLoading(false);
  }, [matchedAddress]);

  return (
    <div>
      <HtmlTooltip title={<React.Fragment>{"Enter address to search and goto location."}</React.Fragment>}>
      <Paper component="form" className={classes.paper}>  
        <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} id="searchField" label="" variant="outlined" size="small" onChange={e => setSearchField(e.target.value)} onKeyDown={handleEnterSubmit} required/>
        <Button className={classes.searchButton} variant="contained" onClick={handleSearch} disabled={disabled}>
          {isLoading ? ( <ReactLoading type={'spin'} color={'#F6A036'} height={20} width={20}/>) : ( <SearchIcon /> ) }
        </Button>
      </Paper>
    </HtmlTooltip> 
    </div>
  );
}